const StarLogo = ({ className }: { className: string }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      width="48"
      height="48"
      rx="24"
      fill="#BB4D00"
    />
    <path
      d="M23.4044 14.3966C23.6248 13.8678 24.3752 13.8678 24.5956 14.3966L27.0335 20.2477C27.1264 20.4707 27.3365 20.623 27.5776 20.6423L33.9056 21.1487C34.4775 21.1945 34.7094 21.907 34.2737 22.2796L29.4524 26.4022C29.2687 26.5593 29.1885 26.8057 29.2446 27.0406L30.7176 33.2047C30.8507 33.7618 30.2436 34.2022 29.7539 33.9036L24.3362 30.6004C24.1298 30.4745 23.8702 30.4745 23.6638 30.6004L18.2461 33.9036C17.7564 34.2022 17.1493 33.7618 17.2824 33.2047L18.7554 27.0406C18.8115 26.8057 18.7313 26.5593 18.5476 26.4022L13.7263 22.2796C13.2906 21.907 13.5225 21.1945 14.0944 21.1487L20.4224 20.6423C20.6635 20.623 20.8736 20.4707 20.9665 20.2477L23.4044 14.3966Z"
      stroke="#F6F5F2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default StarLogo
